import React from "react";
import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import { CATEGORIES } from "../lib/categories";

const FALLBACK_IMG = "https://images.unsplash.com/photo-1518709268805-4e9042af2176?w=1200&q=80";

function categoryName(slug) {
  return CATEGORIES.find((c) => c.slug === slug)?.name || slug;
}

export function ArticleCard({ article, size = "md", index = 0 }) {
  const sizeMap = {
    sm: { img: "aspect-[4/3]", title: "text-lg" },
    md: { img: "aspect-[16/10]", title: "text-xl md:text-2xl" },
    lg: { img: "aspect-[16/9]", title: "text-2xl md:text-3xl" },
  };
  const s = sizeMap[size] || sizeMap.md;
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block bg-white border border-[#E5E5E5] hover:border-[#121212] transition-all duration-300 ceg-fade-up"
      style={{ animationDelay: `${index * 60}ms` }}
      data-testid={`article-card-${article.slug}`}
    >
      <div className={`${s.img} overflow-hidden relative`}>
        <img
          src={article.hero_image || FALLBACK_IMG}
          alt={article.title}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-3 left-3 bg-[#FF3823] text-white text-[10px] uppercase tracking-wider px-2 py-1 font-bold">
          {categoryName(article.category)}
        </span>
      </div>
      <div className="p-5">
        <h3 className={`font-['Outfit'] font-bold ${s.title} tracking-tight leading-tight group-hover:text-[#0055FF] transition-colors`}>
          {article.title}
        </h3>
        <p className="mt-2 text-sm text-[#5C5C5C] line-clamp-2">{article.excerpt}</p>
        <div className="mt-4 flex items-center justify-between text-xs uppercase tracking-wider text-[#5C5C5C]">
          <span>{article.author}</span>
          <span className="flex items-center gap-1"><Clock size={12} /> {article.read_time} min</span>
        </div>
      </div>
    </Link>
  );
}

export function ArticleListItem({ article, index = 0 }) {
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group grid grid-cols-12 gap-4 border-b border-[#E5E5E5] py-5 hover:bg-white transition-colors ceg-fade-up"
      style={{ animationDelay: `${index * 40}ms` }}
      data-testid={`article-list-${article.slug}`}
    >
      <div className="col-span-4 sm:col-span-3 aspect-[4/3] overflow-hidden">
        <img src={article.hero_image || FALLBACK_IMG} alt={article.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
      </div>
      <div className="col-span-8 sm:col-span-9 flex flex-col justify-center">
        <p className="ceg-overline">{categoryName(article.category)}</p>
        <h3 className="font-['Outfit'] font-bold text-lg md:text-xl mt-1 tracking-tight leading-tight group-hover:text-[#0055FF] transition-colors">
          {article.title}
        </h3>
        <p className="hidden sm:block mt-1 text-sm text-[#5C5C5C] line-clamp-2">{article.excerpt}</p>
        <p className="mt-2 text-xs uppercase tracking-wider text-[#5C5C5C]">{article.read_time} min read</p>
      </div>
    </Link>
  );
}

export { categoryName };
